<div class="navigation-button-wrapper" fxFlex fxLayout="column" fxLayoutGap="15px">
  <div *ngIf="showWarningLabel" fxFlex fxLayout="row" fxFlexAlign="center">
    <label class="warning-label">Can’t finish now? No problem! We will save your work.</label>
  </div>
  <div fxFlex fxLayout="row" fxFlexAlign="center">
    <button [disabled]="!validBtn" *ngIf="!saveOnDB" (click)="forwardStateChange.emit(currentState + 1)"
            [ngStyle]="{}" mat-button class="continue-button">
      <label>Continue</label>
    </button>
    <button [disabled]="!validBtn" *ngIf="saveOnDB" (click)="forwardStateChange.emit(currentState + 1)"
            [ngClass]="finish ? 'finish-button' : 'continue-button'" [ngStyle]="{opacity: !!validBtn ? '1' : '0.5' }" mat-button>
      <label [ngStyle]="{cursor: !!validBtn ? 'pointer' : 'default' }" *ngIf="!finish">Save and Continue</label>
      <label [ngStyle]="{cursor: !!validBtn ? 'pointer' : 'default' }" *ngIf="finish">Finish</label>
    </button>
  </div>
  <div *ngIf="hasBack()" (click)="goBack()" fxFlex fxLayout="row" fxFlexAlign="center">
    <a class="back-btn">Back</a>
  </div>
</div>
